// components/GameWrapper.tsx
import React, { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import MazeScene from './MazeScene'; // Import the MazeScene
import BunnyEscapeScene from './BunnyEscapeScene';

// React wrapper for the Phaser game instance
export const GameWrapper = () => {
  const gameRef = useRef(null); // Removed TypeScript type annotation

  useEffect(() => {
    const config = { // Removed TypeScript type annotation
      type: Phaser.AUTO,
      width: 512, // 21 tiles * 16 px
      height: 512,
      backgroundColor: '#000000',
      parent: gameRef.current,
      scene: BunnyEscapeScene,
      physics: { default: 'arcade' },
    };

    const game = new Phaser.Game(config);
    return () => game.destroy(true); // Cleanup on unmount
  }, []);

  return <div ref={gameRef} />;
};